<div class="page">
  <app-simplified-header style="width: 100%"></app-simplified-header>
  <section class="content">
    <div class="not-found-container">
      <img src="assets/imgs/undraw/undraw_page_not_found.svg" />
      <h1>Pagina non trovata</h1>
      <p>La pagina che stai cercando non esiste.</p>
    </div>
  </section>
</div>
